import { Link } from 'react-router-dom';

export default function DemographicsGrid() {
  const demographics = [
    {
      stat: '680,000+',
      label: 'Population',
      bg: 'bg-[#E8C4C4]',
      icon: 'ri-group-line',
    },
    {
      stat: '$52,000',
      label: 'Median Income',
      bg: 'bg-[#C8D5B9]',
      icon: 'ri-money-dollar-circle-line',
    },
    {
      stat: '82%',
      label: 'Hispanic Market',
      bg: 'bg-[#D5D5D5]',
      icon: 'ri-pie-chart-line',
    },
    {
      stat: '15,000+',
      label: 'Small Businesses',
      bg: 'bg-[#D9C8B4]',
      icon: 'ri-store-2-line',
    },
  ];

  return (
    <section className="py-20 bg-[#F5F3EF]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm text-gray-500 font-serif mb-2">Data-Driven Insights</p>
              <h2 className="text-5xl font-bold text-gray-900 mb-2">El Paso by the Numbers</h2>
              <p className="text-3xl font-serif italic text-gray-600">Your Market Awaits</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-7">
          {demographics.map((item, index) => (
            <div
              key={index}
              className="rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`${item.bg} h-80 flex flex-col items-center justify-center p-8`}>
                <div className="w-20 h-20 flex items-center justify-center mb-6">
                  <i className={`${item.icon} text-6xl text-gray-700`}></i>
                </div>
                <div className="text-5xl font-bold text-gray-900 mb-2">{item.stat}</div>
              </div>
              <div className="bg-white p-5 text-center">
                <p className="text-base font-semibold text-gray-700">{item.label}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/demographics"
            className="inline-flex items-center space-x-2 text-[#D2691E] font-semibold hover:text-[#B8571A] transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>Explore Full Demographics Report</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}